/**
 * 'Index.js'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import codes from './codes.store'
import orders from './orders.store'
import app from './app.store'

export default {
  codes,
  orders,
  app
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js